export const NotificationTypeIcon = {
  1: {
    icon: '/static/icons/selective_icon.svg'
  },
  2: {
    icon: '/static/icons/schedule_icon.svg'
  }
};
